import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { fetchQuoteHtml } from '../../../query-api'

export const useFetchQuoteHtml = (quoteId: string) => {
  const { data, ...rest } = useQuery([QueryKeys.QuoteHtml, quoteId], () => fetchQuoteHtml(quoteId), {
    enabled: !!quoteId,
  })

  return { quoteHtml: data?.data, ...rest }
}
